import {
  fetcher,
  messageFromApiErrorBody,
  readJsonResponseBody,
} from '@commenda/utils';

export async function disconnectRootFiCompany(rootFiCompanyId: number): Promise<{
  success: boolean;
  error?: unknown;
}> {
  try {
    const response = await fetcher(
      `rootfi/company/${rootFiCompanyId}/disconnect`,
      {
        method: 'POST',
        body: {},
      }
    );

    if (!response.ok) {
      const errorBody = await readJsonResponseBody(response);
      return {
        success: false,
        error: messageFromApiErrorBody(errorBody, 'Failed to disconnect integration'),
      };
    }

    return { success: true };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to disconnect integration';
    return { success: false, error: errorMessage };
  }
}
